import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../../ui/button';
import CustomSelect from '../../ui/CustomSelect';
import { Calculator } from 'lucide-react';
import { itemVariants } from '../../../utils/animations';
import { months, years } from './utils/payrollConstants';

interface PayrollHeaderProps {
  selectedMonth: number;
  selectedYear: number;
  onMonthChange: (month: number) => void;
  onYearChange: (year: number) => void;
  onGenerateClick: () => void;
  isGenerating: boolean;
}

export default function PayrollHeader({
  selectedMonth,
  selectedYear,
  onMonthChange,
  onYearChange,
  onGenerateClick,
  isGenerating,
}: PayrollHeaderProps) {
  const monthOptions = months.map(m => ({ value: String(m.value), label: m.label }));
  const yearOptions = years.map(y => ({ value: String(y), label: String(y) }));

  return (
    <motion.div
      variants={itemVariants}
      className="flex flex-col md:flex-row md:items-center md:justify-between gap-4"
    >
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Penggajian Terintegrasi</h1>
        <p className="text-gray-500 mt-1">Gaji Pokok + Lembur + Bonus KPI</p>
      </div>
      <div className="flex items-center gap-3">
        <CustomSelect
          value={String(selectedMonth)}
          onChange={v => onMonthChange(parseInt(v))}
          options={monthOptions}
          placeholder="Bulan"
          width="w-36"
        />
        <CustomSelect
          value={String(selectedYear)}
          onChange={v => onYearChange(parseInt(v))}
          options={yearOptions}
          placeholder="Tahun"
          width="w-24"
        />
        <Button
          onClick={onGenerateClick}
          disabled={isGenerating}
          className="bg-emerald-600 hover:bg-emerald-700 text-white"
        >
          <Calculator className="w-4 h-4 mr-2" />
          {isGenerating ? 'Generating...' : 'Generate Payroll'}
        </Button>
      </div>
    </motion.div>
  );
}
